
export const VIDEO = {

    bgVideoGif: require("./bgVideoGIF.mp4"),

    bgVideo: require("./video.mp4")
    
}